// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inline-flex {
  display: inline-flex;
}

.expand {
  margin: 0 8px;
  cursor: pointer;
}

.expand.plus {
  padding: 2px 0 0 0;
}

.minus {
  margin: 0 8px;
}

.apiLinkKey {
  cursor: pointer;
  word-wrap: break-word;
}

.key {
  color: #000;
  font-weight: 600;
  cursor: pointer;
}

.key-header {
  padding: 3px 3px;
  width: 100%;
  color: #000;
  border-bottom: 1px solid #000;
  cursor: pointer;
}

.api-key-filter {
  border: 1px solid #aaa;
  border-radius: 7px;
  padding: 5px 0rem 5px 3rem !important;
  background-color: transparent;
  margin-left: 0;
  min-width: 10rem;
  background-image: url(/assets/theme/images/search.svg);
  background-repeat: no-repeat;
  background-position: left 12px bottom 50%;
  height: 34px;
  z-index: 999;
}

.close {
  position: absolute;
  border-radius: 5px;
  right: 10px;
  z-index: 2;
  border: none;
  top: 22px;
  font-size: 1.18rem;
  cursor: pointer;
  transform: translateX(2px);
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/rest-api-listing/rest-api-listing.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;;AAGA;EACE,aAAA;EACA,eAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,eAAA;EACA,qBAAA;AAAF;;AAGA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAIA;EACE,gBAAA;EACA,WAAA;EAGA,WAAA;EACA,6BAAA;EACA,eAAA;AAHF;;AAMA;EACE,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,sDAAA;EACA,4BAAA;EACA,yCAAA;EACA,YAAA;EACA,YAAA;AAHF;;AAMA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AAHF","sourcesContent":[".inline-flex {\r\n  display: inline-flex;\r\n  // margin: 3px;\r\n}\r\n\r\n.expand {\r\n  margin: 0 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.expand.plus {\r\n  padding: 2px 0 0 0;\r\n}\r\n\r\n.minus {\r\n  margin: 0 8px;\r\n}\r\n\r\n.apiLinkKey {\r\n  cursor: pointer;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.key {\r\n  color: #000;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  // color: #ffffff;\r\n}\r\n\r\n.key-header {\r\n  padding: 3px 3px;\r\n  width: 100%;\r\n  // background: linear-gradient(90deg, #0b00bb 0%, #0764d4 35%, #a1ebfa 100%);\r\n  // color: #ffffff;\r\n  color: #000;\r\n  border-bottom: 1px solid #000;\r\n  cursor: pointer;\r\n}\r\n\r\n.api-key-filter {\r\n  border: 1px solid #aaa;\r\n  border-radius: 7px;\r\n  padding: 5px 0rem 5px 3rem !important;\r\n  background-color: transparent;\r\n  margin-left: 0;\r\n  min-width: 10rem;\r\n  background-image: url(/assets/theme/images/search.svg);\r\n  background-repeat: no-repeat;\r\n  background-position: left 12px bottom 50%;\r\n  height: 34px;\r\n  z-index: 999;\r\n}\r\n\r\n.close {\r\n  position: absolute;\r\n  border-radius: 5px;\r\n  right: 10px;\r\n  z-index: 2;\r\n  border: none;\r\n  top: 22px;\r\n  font-size: 1.18rem;\r\n  cursor: pointer;\r\n  transform: translateX(2px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
